import React from "react"
import { PriceTagIcon } from "../../common/Icons"
import { Link, generatePath } from "react-router-dom"
import { ROUTES } from "../../common/utils"
import "./OrderItem.css"

function OrderItem({ product, currency, orderUUID, type, isNewOrder }) {
  const itemTotal = Number(product.price) * Number(product.quantity)
  function getVariantName(variants) {
    if (variants.includes("default_option")) {
      return ""
    } else {
      return variants.join(", ")
    }
  }
  return (
    <div className="OrderItem">
      <div className="item-meta">
        <span className="item-count">{product.quantity}</span>
        {(product.images &&
          product.images.length > 0 && (
            <div className="item-image">
              <img src={product.images[0]} alt={product.name} />
            </div>
          )) || (
          <div className="item-image-placeholder">
            <PriceTagIcon />
          </div>
        )}
        <div className="item-name">
          <span>
            <Link
              style={{ color: "#898989" }}
              to={{
                pathname: generatePath(ROUTES.CHECKOUT_PRODUCT_DETAILS, {
                  product_id: product.id,
                  type: type,
                  order_uuid: orderUUID
                })
              }}
            >
              {product.name}
            </Link>
          </span>
          {product.variants && <span>{getVariantName(product.variants)}</span>}
        </div>
      </div>
      <span className="item-price">
        {itemTotal.toLocaleString("en", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2
        })}{" "}
        {currency}
      </span>
    </div>
  )
}

export default OrderItem
